import React, { createContext, useContext, useEffect, useState } from 'react';
import { momApi, setMomToken, getMomToken, clearMomToken } from '../lib/mom-api';

const MomAuthContext = createContext(null);

export const useMomAuth = () => {
  const ctx = useContext(MomAuthContext);
  if (!ctx) throw new Error('useMomAuth must be used within MomAuthProvider');
  return ctx;
};

export const MomAuthProvider = ({ children }) => {
  const [mom, setMom] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const t = getMomToken();
      if (!t) { setLoading(false); return; }
      try {
        const me = await momApi.me();
        setMom(me);
      } catch {
        clearMomToken();
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const login = async (email, password) => {
    const res = await momApi.login({ email, password });
    setMomToken(res.access_token);
    setMom(res.user);
    return res.user;
  };

  const register = async (data) => {
    const res = await momApi.register(data);
    setMomToken(res.access_token);
    setMom(res.user);
    return res.user;
  };

  const logout = () => {
    clearMomToken();
    setMom(null);
    window.location.href = '/mom/login';
  };

  const refreshMom = async () => {
    try { const me = await momApi.me(); setMom(me); return me; } catch { return null; }
  };

  return (
    <MomAuthContext.Provider value={{ mom, loading, isAuthenticated: !!mom, login, register, logout, refreshMom, setMom }}>
      {children}
    </MomAuthContext.Provider>
  );
};
